import React, { Component } from "react";
import PropTypes from "prop-types";
import DynamicGrid from "../DynamicGrid";
import { UserDialog } from "../UserDialog";

const Settings = {
	ShowDateFilter: false,
	SortColumn: "full_name",
	UseTicketTypeFilter: false,
	ShowNewButton: true,
	NewButtonText: "Add User",
	ShowGlobalFilter: true,
};

class UserSetup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Users: [],
			ModalVisible: false,
			UsersID: null,
		};
		this.getData();

		this.CloseModal = this.CloseModal.bind(this);
		this.OpenDialog = this.OpenDialog.bind(this);
		Settings.NewButtonAction = this.OpenDialog;
	}

	OpenDialog() {
		this.setState({ UsersID: null, ModalVisible: true });
	}

	componentDidUpdate(prevProps) {
		if (this.props.BuildingID !== prevProps.BuildingID) {
			this.getData();
		}
	}

	CloseModal() {
		this.setState({ ModalVisible: false, SelectedContact: {} });
		this.getData();
	}

	SelectUser(item) {
		this.setState({ UsersID: item, ModalVisible: true });
	}

	async getData() {
		const data = await fetch("User/GetUserSetup", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		});
		var res = await data.json();
		this.setState({ Users: res });
	}
	render() {
		const config = [
			{ header: "Name", columnName: "full_name", visible: true, typeCode: "S" },
			{
				header: "Email",
				columnName: "email_address",
				visible: true,
				typeCode: "S",
			},
			{
				header: "Title",
				columnName: "title",
				visible: true,
				typeCode: "S",
			},
			{
				header: "Buildings",
				columnName: "buildings",
				visible: true,
				typeCode: "S",
			},
		];

		return (
			<div
				style={{
					flex: 1,
					backgroundColor: "#ebebeb",
					overflowY: "auto",
					padding: "4px",
				}}>
				<UserDialog visible={this.state.ModalVisible} UsersID={this.state.UsersID} OnClose={this.CloseModal}></UserDialog>
				<DynamicGrid Title="Users" Configuration={config} DataSet={this.state.Users} Settings={Settings} OnRowClick={(row) => this.SelectUser(row.users_id)} />
			</div>
		);
	}
}

UserSetup.propTypes = {
	BuildingID: PropTypes.string,
};

export default UserSetup;
